import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43cf95d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }

import { CoercableComponent } from "features/feature";
import { coerceComponent } from "util/vue";
import { computed, unref } from "vue";
import "components/common/fields.css";


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
    (e: "update:modelValue", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    title?: CoercableComponent;
    modelValue?: boolean;
}




const component = computed(() => coerceComponent(unref(props.title) || "<span></span>", "span"));

const value = computed({
    get() {
        return !!props.modelValue;
    },
    set(value: boolean) {
        emit("update:modelValue", value);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      class: "toggle",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
    }, null, 512), [
      [_vModelCheckbox, _unref(value)]
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component))))
  ]))
}
}

})